import { render, staticRenderFns } from "./SearchHistoryDrawer.vue?vue&type=template&id=77b09bfe"
import script from "./SearchHistoryDrawer.vue?vue&type=script&lang=js"
export * from "./SearchHistoryDrawer.vue?vue&type=script&lang=js"
import style0 from "./SearchHistoryDrawer.vue?vue&type=style&index=0&id=77b09bfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports